const LoginLoad = (): JSX.Element => (
    <section className="login-screen">
        <div className="login-screen__content"></div>
        <div className="login-screen__media"></div>
    </section>
)

export default LoginLoad
